import { useEffect, useState } from "react";

import { IconPlus } from "@tabler/icons-react";
import { LandscapeRounded } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import { useScreen } from "Screen/ScreenContext";

import { Text } from "@fragments";
import { UserAvatar } from "@components/Community";

import "./styles.scss";

export default function CreatePostButton({
    user,
    enabled,
    anchorRef,
    containerRef,
    onClick,
}) {
    const { t } = useTranslation("community");
    const { bodyRef } = useScreen();
    const [stuck, setStuck] = useState(false);
    const [bounds, setBounds] = useState({ left: 0, width: 0 });

    useEffect(() => {
        const body = bodyRef?.current;
        const container = containerRef?.current;
        if (!body) return;

        let frameId = null;
        let lastLeft = null;
        let lastWidth = null;

        const update = () => {
            frameId = null;
            const anchor = anchorRef?.current;
            const bodyRect = body.getBoundingClientRect();

            if (anchor) {
                const anchorRect = anchor.getBoundingClientRect();
                const earlyOffset = window.innerWidth <= 960 ? 200 : 0;
                setStuck(anchorRect.top - bodyRect.top <= earlyOffset);
            }

            if (containerRef?.current) {
                const cRect = containerRef.current.getBoundingClientRect();
                if (cRect.left !== lastLeft || cRect.width !== lastWidth) {
                    lastLeft = cRect.left;
                    lastWidth = cRect.width;
                    setBounds({ left: cRect.left, width: cRect.width });
                }
            }
        };

        const schedule = () => {
            if (frameId == null) frameId = requestAnimationFrame(update);
        };

        update();
        body.addEventListener("scroll", schedule, { passive: true });
        const ro = new ResizeObserver(schedule);
        ro.observe(body);
        if (container) ro.observe(container);
        return () => {
            body.removeEventListener("scroll", schedule);
            ro.disconnect();
            if (frameId != null) cancelAnimationFrame(frameId);
        };
    }, [bodyRef, anchorRef, containerRef]);

    const visible = enabled && stuck;
    const floaterStyle = bounds.width
        ? { left: bounds.left, width: bounds.width }
        : undefined;

    return (
        <div
            className={`add-post-floater${visible ? " is-visible" : ""}`}
            style={floaterStyle}
            aria-hidden={!visible}
        >
            <div
                className="add-post-button"
                onClick={visible ? onClick : undefined}
            >
                <div className="add-post-user">
                    <UserAvatar user={user} size={32} link={false} />
                    <Text.h4 contrast={2}>{t("group.createPost")}</Text.h4>
                </div>
                <div className="add-post-buttons">
                    <LandscapeRounded className="add-post-button__icon" />
                    <div className="add-btn-post">
                        <IconPlus size={20} />
                    </div>
                </div>
            </div>
        </div>
    );
}
